import React, { useMemo } from "react"

import { ColorSwatch, Tooltip } from "@coval/ui"

import { getDefaultTagColor } from "../constants/tag-colors"
import { normalizeTags } from "../utils/tagNormalization"
import { TagDotList } from "./TagDotList"

interface TagDotsPreviewProps {
  tags?: string[] | null
  tagColorMap?: Record<string, string | null | undefined>
  maxVisibleDots?: number
  className?: string
}

export const TagDotsPreview: React.FC<TagDotsPreviewProps> = ({
  tags = [],
  tagColorMap = {},
  maxVisibleDots = 3,
  className,
}) => {
  const currentTags = useMemo(() => normalizeTags(tags ?? []), [tags])

  if (currentTags.length === 0) {
    return null
  }

  const visibleTags = currentTags.slice(0, maxVisibleDots)
  const overflowCount = Math.max(0, currentTags.length - visibleTags.length)

  return (
    <Tooltip
      content={
        <TagDotList
          tags={currentTags}
          tagColorMap={tagColorMap}
          className="py-1 text-xs"
        />
      }
    >
      <span
        className={`ml-auto flex h-6 shrink-0 items-center gap-1 rounded-sm bg-surface-1 px-2 text-xs font-medium text-coval-text-muted ${className ?? ""}`}
        aria-label={`${currentTags.length} ${currentTags.length === 1 ? "tag" : "tags"}`}
      >
        {visibleTags.map((tag) => (
          <ColorSwatch
            key={tag}
            color={tagColorMap[tag] || getDefaultTagColor(tag)}
          />
        ))}
        {overflowCount > 0 && <span>+{overflowCount}</span>}
      </span>
    </Tooltip>
  )
}
